//
//
//
//
//
//
//
//
//
//

export default {
  //   props: ['state', 'title'],
  props: {
    onClick: {
      type: Function,
      required: true
    },
    title: {
      type: String,
      required: false
    },
    icon: {
      type: String,
      required: false
    },
    btnClass: {
      type: String,
      required: false
    },
    showProgress: {
      type: Boolean,
      required: false
    },
    progressLevel: {
      type: String,
      required: false
    }
  },
  methods: {
    btnClick: function btnClick() {
      this.isProcess = true;
      this.onClick();
    },
    disabled: function disabled() {
      this.isProcess = true;
    },
    enabled: function enabled() {
      this.isProcess = false;
      this.progressPercent = '0';
    }
  },
  data: function data() {
    // process = false
    var btnIcon = 'check';
    var defaultCass = 'info';
    if (this.icon !== undefined) {
      btnIcon = this.icon;
    }
    if (this.btnClass !== undefined) {
      defaultCass = this.btnClass;
    }
    var defaultProgress = '0';
    if (this.progressLevel !== undefined) {
      defaultProgress = this.progressLevel;
    }
    var obj = {
      isProcess: false,
      btnIcon: btnIcon,
      buttonClass: defaultCass,
      progressPercent: defaultProgress
    };
    return obj;
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/button.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/button.vue
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 29 30 31 33 36 37 38 39 42 44 45 46 47 48 49 50